export const NATIVE_TOKEN_ADDRESS = '0x0000000000000000000000000000000000000000'
export const IPFS_GATEWAY_URL = "https://cloudflare-ipfs.com/ipfs"
export const COINBASE_CLAIM_URL = "https://base.app/claim?tk=code&k=<CODE>&c=<CHAIN_ID>&v=<VERSION>&src=d" //'https://wallet.coinbase.com/claim?tk=code&k=<CODE>&c=<CHAIN_ID>&v=<VERSION>&src=d'
export const COINBASE_WALLET_DEEPLINK = 'https://go.cb-w.com/dapp?cb_url=<ENCODED_CLAIM_URL>'
export const ZK_STACK_INITCODE = "0x0100085945c7a3bfac4a462d701734006009f3d2b500adcc47930ff019b4688a";
